/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Gl_7_DInputs */

const en_mk_tut_gl_7_d = /** @type {(inputs: Mk_Tut_Gl_7_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The set of house rules — tone, prices, prohibitions — an agent reads before it works.`)
};

const id_mk_tut_gl_7_d = /** @type {(inputs: Mk_Tut_Gl_7_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kumpulan aturan rumah — nada bicara, harga, larangan — yang dibaca agen sebelum bekerja.`)
};

/**
* | output |
* | --- |
* | "The set of house rules — tone, prices, prohibitions — an agent reads before it works." |
*
* @param {Mk_Tut_Gl_7_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_gl_7_d = /** @type {((inputs?: Mk_Tut_Gl_7_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Gl_7_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_gl_7_d(inputs)
	return en_mk_tut_gl_7_d(inputs)
});